import { forwardRef } from "react";

import { Form } from "@shared/components/Form";
import { FormAutocompleteProps } from "@shared/components/Form/types";
import { getAmigobotDoctorsService } from "@modules/prescribers/services/queries/listAmigobotDoctors/service";

export const AmigobotDoctorsAutocomplete = forwardRef<
  HTMLInputElement,
  Omit<FormAutocompleteProps, "options">
>((props, ref) => {
  return (
    <Form.Autocomplete {...props} ref={ref} queryHook={getAmigobotDoctorsService} />
  );
});

AmigobotDoctorsAutocomplete.displayName = "AmigobotDoctorsAutocomplete";
